<div class="left">
    <ng-content select="[slot='left']"></ng-content>
</div>
<div class="right">
    <ng-content select="[slot='right']"></ng-content>
</div>